/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum MealType {
  MealTypeUnknown = "MealTypeUnknown",
  Breakfast = "Breakfast",
  AllInclusive = "AllInclusive",
  AllInclusivePlus = "AllInclusivePlus",
  AllInclusivePremium = "AllInclusivePremium",
  AllInclusiveUltra = "AllInclusiveUltra",
  AllInclusiveLight = "AllInclusiveLight",
  FullBoard = "FullBoard",
  FullBoardPlus = "FullBoardPlus",
  HalfBoard = "HalfBoard",
  HalfBoardPlus = "HalfBoardPlus",
  HalfBoardUltra = "HalfBoardUltra",
  Special = "Special",
  None = "None",
  Program = "Program",
}

export function mealTypeFromJSON(object: any): MealType {
  switch (object) {
    case 0:
    case "MealTypeUnknown":
      return MealType.MealTypeUnknown;
    case 1:
    case "Breakfast":
      return MealType.Breakfast;
    case 2:
    case "AllInclusive":
      return MealType.AllInclusive;
    case 3:
    case "AllInclusivePlus":
      return MealType.AllInclusivePlus;
    case 4:
    case "AllInclusivePremium":
      return MealType.AllInclusivePremium;
    case 5:
    case "AllInclusiveUltra":
      return MealType.AllInclusiveUltra;
    case 6:
    case "AllInclusiveLight":
      return MealType.AllInclusiveLight;
    case 7:
    case "FullBoard":
      return MealType.FullBoard;
    case 8:
    case "FullBoardPlus":
      return MealType.FullBoardPlus;
    case 9:
    case "HalfBoard":
      return MealType.HalfBoard;
    case 10:
    case "HalfBoardPlus":
      return MealType.HalfBoardPlus;
    case 11:
    case "HalfBoardUltra":
      return MealType.HalfBoardUltra;
    case 12:
    case "Special":
      return MealType.Special;
    case 13:
    case "None":
      return MealType.None;
    case 14:
    case "Program":
      return MealType.Program;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum MealType"
      );
  }
}

export function mealTypeToJSON(object: MealType): string {
  switch (object) {
    case MealType.MealTypeUnknown:
      return "MealTypeUnknown";
    case MealType.Breakfast:
      return "Breakfast";
    case MealType.AllInclusive:
      return "AllInclusive";
    case MealType.AllInclusivePlus:
      return "AllInclusivePlus";
    case MealType.AllInclusivePremium:
      return "AllInclusivePremium";
    case MealType.AllInclusiveUltra:
      return "AllInclusiveUltra";
    case MealType.AllInclusiveLight:
      return "AllInclusiveLight";
    case MealType.FullBoard:
      return "FullBoard";
    case MealType.FullBoardPlus:
      return "FullBoardPlus";
    case MealType.HalfBoard:
      return "HalfBoard";
    case MealType.HalfBoardPlus:
      return "HalfBoardPlus";
    case MealType.HalfBoardUltra:
      return "HalfBoardUltra";
    case MealType.Special:
      return "Special";
    case MealType.None:
      return "None";
    case MealType.Program:
      return "Program";
    default:
      return "UNKNOWN";
  }
}

export function mealTypeToNumber(object: MealType): number {
  switch (object) {
    case MealType.MealTypeUnknown:
      return 0;
    case MealType.Breakfast:
      return 1;
    case MealType.AllInclusive:
      return 2;
    case MealType.AllInclusivePlus:
      return 3;
    case MealType.AllInclusivePremium:
      return 4;
    case MealType.AllInclusiveUltra:
      return 5;
    case MealType.AllInclusiveLight:
      return 6;
    case MealType.FullBoard:
      return 7;
    case MealType.FullBoardPlus:
      return 8;
    case MealType.HalfBoard:
      return 9;
    case MealType.HalfBoardPlus:
      return 10;
    case MealType.HalfBoardUltra:
      return 11;
    case MealType.Special:
      return 12;
    case MealType.None:
      return 13;
    case MealType.Program:
      return 14;
    default:
      return 0;
  }
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
